import { render, staticRenderFns } from "./ViewPatientEdit.vue?vue&type=template&id=6ea32114&"
import script from "./ViewPatientEdit.vue?vue&type=script&lang=js&"
export * from "./ViewPatientEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports